import React, { Component } from "react";
import "./styles.scss";

// Popup shown when a user adds a product to the cart. The comment is optional:
// confirming with an empty box adds the item with no comment.
export class AddToCartModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
    };
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCommentChange(event) {
    this.setState({ comment: event.target.value });
  }

  handleConfirm() {
    const { comment } = this.state;
    const trimmed = comment.trim();
    this.props.onConfirm(trimmed || null);
    this.setState({ comment: "" });
  }

  handleCancel() {
    this.setState({ comment: "" });
    this.props.onCancel();
  }

  render() {
    const { isOpen, productName } = this.props;
    const { comment } = this.state;

    if (!isOpen) {
      return null;
    }

    return (
      <div className="add-to-cart-modal-overlay">
        <div className="add-to-cart-modal">
          <div className="modal-header">
            <h4 className="modal-title">Add to cart</h4>
            <button
              type="button"
              className="close"
              onClick={this.handleCancel}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            {productName && (
              <div className="product-name">
                <strong>Product:</strong> {productName}
              </div>
            )}
            <div className="form-group">
              <label htmlFor="cartItemComment">Add a comment (optional):</label>
              <textarea
                id="cartItemComment"
                className="form-control"
                rows="3"
                maxLength="500"
                placeholder="Add a note for this item..."
                value={comment}
                onChange={this.handleCommentChange}
              />
              <small className="form-text text-muted">
                {comment.length}/500 characters
              </small>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleConfirm}
            >
              Add to cart
            </button>
          </div>
        </div>
      </div>
    );
  }
}
